import { Button, Heading } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import obtenerTitular from '../../../services/obtenerTitular';
import { Loading } from '../../Common/Loading';
import { agregarPagos } from '../../../services/agregarPagos';
import uploadComprobantePago from '../../../helpers/uploadComprobantePago';
import { useTranslation } from 'react-i18next';

const AgregarPagos = () => {

  const { t } = useTranslation();

  const { titularId } = useParams();
  const [titular, setTitular] = useState({});
  const [error, setError] = useState({ error: false, msg: '' });
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [pago, setPago] = useState({ monto: 0, comprobante: '' });
  const [isDisabled, setIsDisabled] = useState();

  useEffect(() => {
    obtenerTitular(titularId)
      .then((res) => {
        if (res.status === 200) {
          setTitular(res.data.titular);
        } else {
          setError({ error: true, msg: 'No se logró obtener los datos' });
        }
      })
      .catch((err) => setError({ error: true, msg: err }))
      .finally(() => setIsLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [titularId]);

  const handleOnChange = (e, key) => {
    setPago({ ...pago, [key]: e.target.value });
  };

  const handleComprobanteOnChange = (e) => {
    if (!e.target.files[0]) return;
    setPago({ ...pago, comprobante: e.target.files[0] });
  };

  const handleAgregarPago = async () => {
    setIsDisabled(true);
    const res = await agregarPagos(titularId, pago.monto);

    if (!res) {
      setError({
        error: true,
        msg: t('ERROR_REGISTERING_PAYMENT'),
      });
      setIsDisabled(false);
      return;
    }

    const comprobante = await uploadComprobantePago(
      titularId,
      pago.comprobante,
      res.data.pago.id
    );

    if (!comprobante) {
      setError({
        error: true,
        msg: t('ERROR_UPLOADING_RECEIPT'),
      });
      setIsDisabled(false);
      return;
    }

    navigate('/socios');
  };

  if (isLoading) return <Loading />;

  return (
    <div className="p-5">
      <Heading as="h1">{t('ADD_PAYMENTS_TO_HOLDER')}</Heading>
      <div className="pt-3 pb-2">
        <Heading
          as="h2"
          size="md"
        >
          {t('HOLDER_NAME')} {titular?.nombre} {titular?.apellidos}
        </Heading>
      </div>
      {error.error && <span className="text-danger">{error.msg}</span>}
      <div className="py-2">
        <div className="py-1">
          <label htmlFor="comprobante">{t('PAYMENT_RECEIPT')}</label>
          <input
            className="mx-3"
            id="comprobante"
            type="file"
            accept="image/png, image/jpeg"
            onChange={handleComprobanteOnChange}
          />
        </div>
        <div className="py-1">
          <label htmlFor="monto">{t('AMOUNT')}:</label>
          <input
            className="mt-2 form-control w-25"
            id="monto"
            type="number"
            value={pago.monto}
            placeholder={t('ENTER_PAYMENT_AMOUNT')}
            onChange={(e) => handleOnChange(e, 'monto')}
          />
        </div>
      </div>
      <div className="pt-3 pb-2 d-flex justify-content-between w-25">
        <Button
          colorScheme="yellow"
          onClick={() => navigate('/socios')}
          isDisabled={isDisabled}
        >
          {t('CANCEL')}
        </Button>
        <Button
          colorScheme="blue"
          onClick={handleAgregarPago}
          isDisabled={!pago.comprobante || !pago.monto || isDisabled}
        >
          {t('ADD_PAYMENT')}
        </Button>
      </div>
    </div>
  );
};

export default AgregarPagos;
